import { useCallback, useState } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import { skipDislikeConfirmAtom } from "@/atoms/dislikeConfirmAtom";

interface UseDislikeInteractionProps {
  onConfirm: () => void;
}

/**
 * 興味なしインタラクションの共通ロジックを管理するカスタムフック
 */
export const useDislikeInteraction = ({ onConfirm }: UseDislikeInteractionProps) => {
  const [showDislikeModal, setShowDislikeModal] = useState(false);
  const skipDislikeConfirm = useAtomValue(skipDislikeConfirmAtom);
  const setSkipDislikeConfirm = useSetAtom(skipDislikeConfirmAtom);

  const handleDislikeClick = useCallback(() => {
    if (skipDislikeConfirm) {
      onConfirm();
    } else {
      setShowDislikeModal(true);
    }
  }, [skipDislikeConfirm, onConfirm]);

  const handleDislikeConfirm = useCallback(
    (skipNextTime: boolean) => {
      if (skipNextTime) {
        setSkipDislikeConfirm(true);
      }
      onConfirm();
      setShowDislikeModal(false);
    },
    [onConfirm, setSkipDislikeConfirm]
  );

  return {
    showDislikeModal,
    setShowDislikeModal,
    handleDislikeClick,
    handleDislikeConfirm
  };
};
